export default __webpack_public_path__ + "static/media/home-candle.7bc136d6.svg";